import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { SeasonalLogo } from './seasonal-logo';
import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  Router,
  NavigationEnd,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { TuiAppearance, TuiButton, TuiDataList, TuiDropdown, TuiInput } from '@taiga-ui/core';
import { TuiTabs } from '@taiga-ui/kit';
import { TuiNavigation } from '@taiga-ui/layout';
import { CurrentUserService } from '../../shared/services/current-user.service';
import { environment } from 'src/environments/environment';
import { ActiveInterviewRecordingService } from '../../shared/services/active-interview-recording.service';
import { SpeechRecognitionService } from '../../shared/services/speech-recognition.service';
import { IsAdminDirective } from '../../shared/directives/is-admin.directive';

@Component({
  selector: 'app-navigation',
  providers: [SeasonalLogo],
  imports: [
    FormsModule,
    RouterLink,
    RouterLinkActive,
    TuiAppearance,
    TuiButton,
    TuiDataList,
    TuiDropdown,
    TuiNavigation,
    TuiTabs,
    TuiInput,
    AsyncPipe,
    RouterOutlet,
    IsAdminDirective,
  ],
  templateUrl: './navigation.html',
  styleUrl: './navigation.scss',
})
export class Navigation {
  readonly seasonalLogo = inject(SeasonalLogo);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  readonly visualizationEditor = signal(false);
  constructor() {
    const update = () => {
      let route = this.router.routerState.snapshot.root;
      while (route.firstChild) route = route.firstChild;
      this.visualizationEditor.set(route.data['visualizationEditor'] === true);
    };
    update();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef)).subscribe(update);
  }
  private readonly speechService = inject(SpeechRecognitionService);
  private readonly activeInterviewRecording = inject(ActiveInterviewRecordingService);

  expanded = signal(false);
  user$ = inject(CurrentUserService).user$;
  open = false;
  switch = false;
  readonly routes: any = {};
  readonly breadcrumbs = [
    'Home',
    'Angular',
    'Repositories',
    'Taiga UI',
  ];
  mvcAppUrl = environment.mvcAppUrl;
  handleToggle(): void {
    this.expanded.update((e) => !e);
  }

  onSidebarLinkClick(event: MouseEvent, url: string): void {
    if (!this.shouldBlockSidebarNavigation(event)) {
      return;
    }

    event.preventDefault();
    this.activeInterviewRecording.requestLeavePatientRecord(url);
  }

  private shouldBlockSidebarNavigation(event: MouseEvent): boolean {
    if (!this.speechService.isRecording()) {
      return false;
    }

    if (!this.isPrimaryUnmodifiedClick(event)) {
      return false;
    }

    const anchor = event.currentTarget;
    if (!(anchor instanceof HTMLAnchorElement) || anchor.target === '_blank') {
      return false;
    }

    return true;
  }

  private isPrimaryUnmodifiedClick(event: MouseEvent): boolean {
    return (
      event.button === 0 &&
      !event.ctrlKey &&
      !event.metaKey &&
      !event.shiftKey &&
      !event.altKey
    );
  }

}
